import { z } from 'zod';

/**
 * Build-time configuration. CI writes these from the CDK stack outputs, so a
 * missing value means the deploy pipeline skipped a step — fail loudly.
 */
const schema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_USER_POOL_ID: z.string().min(1),
  VITE_USER_POOL_CLIENT_ID: z.string().min(1),
  VITE_ENV: z.enum(['dev', 'prod']).default('dev'),
});

const parsed = schema.safeParse(import.meta.env);

export const config = parsed.success
  ? parsed.data
  : ({
      VITE_API_URL: '',
      VITE_USER_POOL_ID: '',
      VITE_USER_POOL_CLIENT_ID: '',
      VITE_ENV: 'dev',
    } as z.infer<typeof schema>);

/** True when the app was built without backend configuration (local landing-page work). */
export const isUnconfigured = !parsed.success;
